const NAME_KEYS = new Set(['name', 'fullname']);

export const isNameField = (key) => NAME_KEYS.has(String(key ?? '').toLowerCase().replace(/[^a-z]/g, ''));

// "dr. anjali TEWARI" -> "Dr. Anjali Tewari"; matches the backend's title-cased scan response.
export const toTitleCase = (value) => {
  if (typeof value !== 'string') return value;
  return value.trim().toLowerCase().replace(/(^|[\s.\-'])(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());
};
